import { render, staticRenderFns } from "./admin-linguas.vue?vue&type=template&id=0578380b&scoped=true&"
import script from "./admin-linguas.vue?vue&type=script&lang=js&"
export * from "./admin-linguas.vue?vue&type=script&lang=js&"
import style0 from "./admin-linguas.vue?vue&type=style&index=0&id=0578380b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0578380b",
  null
  
)

export default component.exports